<template>
  <div>
    <create-doctor
      fetchClinicsBy="superAdmin" />
  </div>
</template>

<script>

import createDoctor from '../../components/doctors/createDoctor.vue';

export default {
  components: {
      createDoctor,
  },
  data:()=>({
  }),
};
</script>
